import { render, staticRenderFns } from "./Identite.vue?vue&type=template&id=038939a2&"
import script from "./Identite.vue?vue&type=script&lang=js&"
export * from "./Identite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Identite.vue"
export default component.exports